// @flow
import React from 'react';
import { Modal } from 'antd';
import { SpH5, SpButton } from 'components/DesignKit';

type Props = {
  visible: boolean,
  close: Function,
  submit: Function,
  selectedOffline: Object,
};

const DeleteSelectedOfflinePaymentPage = (props: Props) => {
  const {
    visible,
    close,
    submit,
    selectedOffline,
  } = props;

  const deleteSelectedOfflinePayment = () => {
    submit(selectedOffline && selectedOffline.paymentPage && selectedOffline.paymentPage.gid);
  };

  return (
    <Modal
      centered
      closable={false}
      visible={visible}
      footer={[
        <SpButton onClick={() => close()} type="secondary">Cancel</SpButton>,
        <SpButton onClick={deleteSelectedOfflinePayment} type="danger">Delete</SpButton>,
      ]}
      title="Delete Offline Payment"
    >
      <div className="px-4">
        <h6 className="mt-1 mb-2">Are you sure you want to delete this offline payment?</h6>
        <SpH5 className="pb-3">
          <div>
            {(selectedOffline.paymentPage && selectedOffline.paymentPage.name) ? selectedOffline.paymentPage.name : <>&#8211;</>}
          </div>
        </SpH5>
      </div>
    </Modal>
  );
};

// $FlowFixMe
export default DeleteSelectedOfflinePaymentPage;
